import { AxiosResponse, Canceler } from 'axios';
import { IApiResult, IPaginationResponseDto, IStoryPriceSettingSchedule } from '../types';
import settings from '../settings';
import api from './base';
import { StatusFilterValue } from '../../pages/saleStory/SaleStoryList';

export function fetchStoryPriceSettingSchedules(
  page: number,
  limit: number,
  storyId?: number,
  price?: number,
  status?: StatusFilterValue.Applied | StatusFilterValue.Scheduled,
): [Promise<AxiosResponse<IPaginationResponseDto<IStoryPriceSettingSchedule>>>, Canceler] {
  const uri = `${settings.getApiURI()}/story-admin/v3/price-setting-schedules`;

  return api.getWithCancel(uri, {
    params: {
      page,
      limit,
      storyId,
      price,
      status,
    },
  });
}

export function createStoryPriceSettingSchedule(
  storyId: number,
  { price, startsAt }: Partial<IStoryPriceSettingSchedule>,
): Promise<AxiosResponse<IApiResult<IStoryPriceSettingSchedule>>> {
  const uri = `${settings.getApiURI()}/story-admin/v3/stories/${storyId}/price-setting-schedules`;

  return api.http.post(uri, {
    price,
    startsAt,
  });
}

export function deleteStoryPriceSettingSchedule(scheduleId: number): Promise<AxiosResponse<IApiResult<IStoryPriceSettingSchedule>>> {
  const uri = `${settings.getApiURI()}/story-admin/v3/price-setting-schedules/${scheduleId}`;

  return api.http.delete(uri);
}
